import { render, staticRenderFns } from "./CompleteIdentityVerification.vue?vue&type=template&id=42f0c94c&scoped=true"
import script from "./CompleteIdentityVerification.vue?vue&type=script&lang=js"
export * from "./CompleteIdentityVerification.vue?vue&type=script&lang=js"
import style0 from "./CompleteIdentityVerification.vue?vue&type=style&index=0&id=42f0c94c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f0c94c",
  null
  
)

export default component.exports